import React, { useEffect } from 'react';
import Button from '@cpg-its/ads.common.button';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '@cpg-its/ads.common.loading-circle';
import { Grid, Hidden } from '@material-ui/core';
import { Redirect, useHistory, useLocation } from 'react-router';
//import { Link } from 'react-router-dom';
import { sortTableStyles } from '../../../../global/constants/theme/styles/tables/generic-sort-table';
import { TcsmStates } from '../../../../root/tcsm-model';
import { ListPagination } from '../../../../search/components/list-pagination';
import { SearchApp } from '../../../../search/components/search-app';
import { SearchList } from '../../../../search/components/search-list';
import { SearchProps } from '../../models/arc-epi-props';
import { unloadCompensationState } from '../compensation/compensation-history/compensation-history-slice';
import { unloadPersonState } from '../../../account-info/features/personal-info/personal-info-slice';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';
import { unloadRelationshipState } from '../../../account-info/features/relationships/relationships-slice';
import { unloadDependentState } from '../../../account-info/features/dependents/dependents-slice';
import { OfficerAdminItemView } from './institution-officer-item-view';
import { Officer } from './institution-officers-models';
import { setCurrentEmployee, unSetEmploymentState } from '../employment/employment-slice';
import { OfficersListLabels } from './institution-offices-labels';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../constants/routes';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { getGroupAdminsList, reInviteOfficerOrAdmin, removeOfficer } from '../../../../global/ducks/wam-api';
import { useGroupAdmins } from './useGroupAdmins';
import { GroupsState } from '../groups/groups-model';
import { beginGroupAdminRequest, setReinviteStatus, setRemoveStatus, stageOfficerAdminToDelete, dispatchSetGroupAdmins, endGroupAdminRequest } from './institution-officers-slices';
import { ApiStatuses } from '../../../../global/models/api-model';
//import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { MainContent } from '../../../../global/components/layout/main-content-container';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
//import { useParentRoute } from '../../../../global/hooks/useParentRoute';
import { TcsmModal } from '../../../../global/components/tcsm-modal';
import { ButtonWrapper } from '../../../../global/components/layout/button-wrapper';
import { apiErrorClear } from '../../../../global/ducks/base-api';
import { setEmployeeContext, setNavigationContext } from '../../../../global/ducks/app-context';
import { EmployeeContext, NavigationContext } from '../../../../global/models/app-context-model';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { OfficerRemoveConfirmation } from './officer-remove-modal-content';

export function GroupAdminSearch() {
	// const buttonClasses = buttonStyles();
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps.searchSettingsState.epiContent);
	const groupState = useSelector<TcsmStates, GroupsState>(state => state.groupsState);
	const dispatch = useDispatch();
	const tableClasses = sortTableStyles();
	const groupSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.GroupSearch}`);
	const groupAdminSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.GroupAdminSearch}`);
	const { state } = useLocation<any>();
	const history = useHistory();
	const groupAdminDemographics = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.GroupAdministrators}${ArcRoutes.PersonalInformation}`);
	const groupAdminState = useGroupAdmins();
	const initialList = groupAdminState.groupAdmins;
	const implicitAdmins = groupAdminState?.groupAdmins?.filter((admin) => admin?.roles?.mlps?.implicit);
	let seniorLevel = false;
	const showRemove = false;
	//const parentRoute = useParentRoute();
	const gpsItem = useGpsType(GpsType.GROUP_ADMIN_LIST);
	const [open, setOpen] = React.useState(false);
	const [adminRemoveOpen, setAdminRemoveOpen] = React.useState(false);

	const handleClose = () => {
		setOpen(false);
	};

	const handleAdminRemoveClose = () => {
		setAdminRemoveOpen(false);
	};


	useEffect(() => {
		dispatch(apiErrorClear());
		dispatch(unSetEmploymentState());
		dispatch(unloadCompensationState());
		dispatch(unloadPersonState(DemographicAppKeys.arc));
		dispatch(unloadRelationshipState(DemographicAppKeys.arc));
		dispatch(unloadDependentState(DemographicAppKeys.arc));
	}, []);

	const onSetAdmin = (guid: string) => {
		const match = initialList?.filter(x => x.guid === guid)[0];
		if (match) {
			dispatch(setCurrentEmployee(match));
			dispatch(setEmployeeContext(EmployeeContext.GroupAdmin));
			dispatch(setNavigationContext(NavigationContext.GroupAdmin));
		}

		history.push(groupAdminDemographics);
	};


	const onReinviteSuccess = () => {
		setOpen(true);
		dispatch(setReinviteStatus(ApiStatuses.Success));
	};


	const onReinviteFail = () => {
		setOpen(true);
		dispatch(setReinviteStatus(ApiStatuses.Failure));
	};

	const reInvite = (guid: string) => {
		dispatch(reInviteOfficerOrAdmin(guid, onReinviteSuccess, onReinviteFail));
	};



	const onRemoveSuccess = () => {
		setAdminRemoveOpen(false);
		dispatch(setRemoveStatus(ApiStatuses.Success));
		dispatch(beginGroupAdminRequest());
		dispatch(getGroupAdminsList(groupState?.currentGroup?.client_number, (response) => { dispatchSetGroupAdmins(response, dispatch); },
			() => {
				dispatch(endGroupAdminRequest());
			},
		));

	};


	const onRemovFail = () => {
		setAdminRemoveOpen(false);
		dispatch(setRemoveStatus(ApiStatuses.Failure));
	};

	const cancelRemove = () => {
		dispatch(stageOfficerAdminToDelete(null));
		setAdminRemoveOpen(false);
	};

	const remove = (officer: Officer) => {
		dispatch(stageOfficerAdminToDelete(officer));
		setAdminRemoveOpen(true);
	};

	const confirmOfficerRemove = (rolesToRemove: string[]) => {
		dispatch(
			removeOfficer(
				groupAdminState?.officerToRemove,
				rolesToRemove,
				onRemoveSuccess,
				onRemovFail),
		);
	};


	if (initialList?.some(a => a?.has_previous_invitation)) seniorLevel = true;


	if (!groupState.currentGroup) {
		return (
			<Redirect to=
				{
					{
						pathname: groupSelect,
						state: {
							actionLink: groupAdminSelect,
							finalAction: state?.actionLink,
						},
					}
				}
			/>);
	}

	if (!groupAdminState.groupAdminsLoaded) {
		return (<Loader />);
	}

	function RenderDisabledAdminMessage() {
		// Only show warning if any item has the warning.
		if (implicitAdmins?.length === 0) return null;

		return (
			<ContentSpacer>
				<p>
					<span className='style-red'>* </span>
					{searchSettings?.disabledAdminMessage || 'These administrators cannot be removed or edited.'}
				</p>
			</ContentSpacer>
		);
	}

	return (
		<>
			<ContentSpacer>
				<Grid container>
					<MainContent>

						<PageHeader
							headerText={searchSettings?.groupAdminListTitle}
							description={searchSettings?.groupAdminsListDescription}
						/>


						{ /*<ContentSpacer><Link className={buttonClasses.secondaryButton} to={`${parentRoute}${ArcRoutes.GroupAdminAdd}`}>{searchSettings.addGroupAdminsButtonText}</Link></ContentSpacer>*/}

					</MainContent>

					<SideBarContent>
						<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
					</SideBarContent>

				</Grid>
			</ContentSpacer>

			<TcsmModal
				open={open}
				handleClose={handleClose}
			>
				<ContentSpacer>
					<h3>{searchSettings.inviteAdminTitle}</h3>
					<p>{groupAdminState.reInviteStatus === ApiStatuses.Success ? searchSettings.inviteAdminSuccessModalDescription : searchSettings.inviteAdminFailModalDescription}</p>
				</ContentSpacer>
				<ButtonWrapper flexEnd>
					<Button type='button' buttonStyle='primary' onClick={handleClose} text={searchSettings.inviteAdminConfirmButton} />
				</ButtonWrapper>

			</TcsmModal>
			<TcsmModal
				open={adminRemoveOpen}
				handleClose={handleAdminRemoveClose}
			>
				<OfficerRemoveConfirmation
					officerToRemove={groupAdminState.officerToRemove}
					settings={searchSettings}
					cancelAction={cancelRemove}
					confirmAction={confirmOfficerRemove}
				/>
			</TcsmModal>

			<RenderDisabledAdminMessage />
			<SearchApp initialList={initialList} appName={`${groupState?.currentGroup?.group_id}-AdminSearch`}>

				<div className={tableClasses.sortTable}>
					<Hidden xsDown>
						<OfficersListLabels settings={searchSettings} isSenior={seniorLevel} />
					</Hidden>
					<div className='sort-table-content'>
						<SearchList
							renderList={
								(item: Officer) => {
									return <OfficerAdminItemView key={item.id} item={item} settings={searchSettings} onSetOfficer={onSetAdmin} reIniviteOfficer={reInvite} removeOfficer={remove} showAction={seniorLevel} showRemove={showRemove} ></OfficerAdminItemView>;
								}
							}
							renderPagination={
								(totalCounts, name) => {
									return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings.nextButton} prevButton={searchSettings.previousButton} />;
								}
							}
							emptyMessage={searchSettings.emptyListMessage}
						/>
					</div>
				</div>
				<Hidden mdUp>
					<SideBarContent>
						<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
					</SideBarContent>
				</Hidden>

			</SearchApp>
		</>
	);

}